import {
  containsNumber,
  containsUpperCaseLetter,
  containsLowerCaseLetter,
  hasValidLength
} from 'helpers/password_validator';

angular.module('public').controller('PasswordResetCtrl', ["$scope", function($scope) {
  $scope.data = {};
  $scope.containsNumber = function() {
    return containsNumber($scope.data.password);
  };
  $scope.containsUpperCaseLetter = function() {
    return containsUpperCaseLetter($scope.data.password);
  };
  $scope.containsLowerCaseLetter = function() {
    return containsLowerCaseLetter($scope.data.password);
  };
  return $scope.hasValidLength = function() {
    return hasValidLength($scope.data.password);
  };
}]);
